export const filterList = (list = [], searchText = '', fields = []) => {
    const normalizedSearch = (searchText || '').trim().toLowerCase();
    if (!normalizedSearch) {
        return list;
    }

    return list.filter((item) =>
        fields.some((field) => {
            const value = typeof field === 'function' ? field(item) : item?.[field];
            return String(value || '').toLowerCase().includes(normalizedSearch);
        })
    );
};
